import CopyToClipboard from 'react-copy-to-clipboard';
import Blanket from '../../common/Blanket';
import Button from '../../common/Button';
import FixedAD, { FIXED_AD_ID } from '../../common/FixedAD';
import Dialog from '../Dialog';
import iconKakao from '../../../img/ico_kakao.png';
import iconKakao2X from '../../../img/ico_kakao@2x.png';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getShareLinkPeriod, MAX_STRING_LENGTH, ProgressSpinner } from '../ShareDocumentLinkDialog';
import { BUTTON_UNIKEY, PRODUCT_TYPE } from '../../../define/global';
import { useAppDataSliceSelector } from '../../../store/modules/appData';

const MobileADNDialogWrapper = styled.div`
  display: flex;
  width: 100%;
  height: fit-content;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  @media (orientation: portrait) {
    flex-direction: column;
  }
`;

const MobileDialogHolder = styled.div`
  width: 322px;
  height: 250px;
  @media (orientation: portrait) {
    height: 222px;
  }

  position: relative;
  /* background: blue; */
`;

const DialogMobileBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 322px;
  height: 202px;
  box-sizing: border-box;
  @media (orientation: portrait) {
    height: 174px;
  }
`;

const MobileSharLinkWrapper = styled.div`
  width: 298px;
  height: 94px;
  margin: 10px 11px;
  background-color: #ffffff;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
`;

const MobileShareLinkCreator = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  box-sizing: border-box;
`;

const MobileShareLinkInputText = styled.div`
  height: 40px;
  font-size: 14px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5e6266;
  //border-radius: 2px;
  border: solid 1px #b1b6bb;
  box-sizing: border-box;
  padding-left: 12px;
  overflow: hidden;
  padding: 11px 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;

  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  border-right: none;

  ${({ disable }) => {
    return (
      disable &&
      css`
        color: #c1c1c1;
        cursor: not-allowed;
      `
    );
  }};

  ${({ normal }) => {
    return (
      normal &&
      css`
        font-weight: 400;
      `
    );
  }};
`;

const MobileShareLinAgent = styled.div`
  margin-top: 14px;
  width: 100%;
  height: 40px;
  display: flex;
  box-sizing: border-box;
`;

const MobileDescriptionBody = styled.div`
  width: 297px;
  height: 38px;
  font-size: 13px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #96999c;
  margin-bottom: 24px;
  box-sizing: border-box;
  padding-top: 6px;
`;

const MobileDescriptionBodyList = styled.ul`
  margin: 0;
  padding: 0;
  padding-left: 25px;
`;
const MobileDescriptionBodyListItem = styled.li``;
const MobileDescriptionBodyListItemText = styled.span`
  position: relative;
  left: -7px;
`;

const MobileADBox = styled.div`
  width: 300px;
  height: 250px;
  background: white;

  @media (orientation: portrait) {
    margin-top: 16px;
  }
  @media (orientation: landscape) {
    margin-left: 16px;
  }
`;

export default function ShareDocumentLinkDialogMobile({
  isShow,
  onClickCloseBtn,
  genShareLink,
  shareLinkState,
  tempShareLinkText,
  genEllipsis,
  onCopy,
  executeTime,
  onClickShareKakao
}) {
  const { t } = useTranslation();
  const appData = useAppDataSliceSelector();

  return (
    <Blanket>
      <MobileADNDialogWrapper>
        <MobileDialogHolder>
          <Dialog
            title={t('ShareDocumentLinkDialog.ShareLink')}
            showCloseBtn
            showTitleSeperateLine
            onClickCloseBtn={onClickCloseBtn}
            isShow={isShow}
            isBlanketTransparent>
            <DialogMobileBody>
              <MobileSharLinkWrapper>
                <MobileShareLinkCreator>
                  <MobileShareLinkInputText
                    disable={!shareLinkState.isGeneratedShareLink}
                    normal={!shareLinkState.isGeneratedShareLink}>
                    {genEllipsis(tempShareLinkText, MAX_STRING_LENGTH)}
                  </MobileShareLinkInputText>
                  {shareLinkState.isGeneratedShareLink ? (
                    <CopyToClipboard onCopy={onCopy} text={tempShareLinkText}>
                      <Button
                        cssExt={css`
                          min-width: 87px;
                          border-top-left-radius: 0px;
                          border-bottom-left-radius: 0px;
                          background: #f4f4f4;
                          font-weight: 700;
                          color: #2f3133;
                        `}
                        uniKey={BUTTON_UNIKEY.SHARED_LINK_COPY_NEW_BTN}
                        onClick={(e) => {
                          e.target.blur();
                        }}>
                        {t('ShareDocumentLinkDialog.Copy')}
                      </Button>
                    </CopyToClipboard>
                  ) : (
                    <Button
                      cssExt={css`
                        min-width: 87px;
                        border-top-left-radius: 0px;
                        border-bottom-left-radius: 0px;
                        font-weight: 700;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      `}
                      primary
                      onClick={genShareLink}
                      uniKey={BUTTON_UNIKEY.SHARED_LINK_GEN_BTN}
                      executeTime={executeTime.current}>
                      {shareLinkState.isInProcessGenerating ? (
                        <ProgressSpinner width="32px" height="32px" />
                      ) : (
                        t('ShareDocumentLinkDialog.Create')
                      )}
                    </Button>
                  )}
                </MobileShareLinkCreator>
                <MobileShareLinAgent>
                  <Button
                    cssExt={css`
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      border: none;
                      min-width: 298px;
                      height: 40px;
                      border-top-left-radius: 0px;
                      border-bottom-left-radius: 0px;
                      font-size: 14px;
                      font-weight: 400;
                      color: #191600;
                      background-color: #fee500;
                      &:hover {
                        background: #fee500;
                      }
                      &:active {
                        background: #fee500;
                      }
                    `}
                    onClick={onClickShareKakao}>
                    <img
                      width="32px"
                      height="32px"
                      src={iconKakao}
                      srcSet={iconKakao2X}
                      alt="shareKakao"></img>
                    {t('ShareDocumentLinkDialog.ShareKakao')}
                  </Button>
                </MobileShareLinAgent>
              </MobileSharLinkWrapper>
              <MobileDescriptionBody>
                <MobileDescriptionBodyList>
                  <MobileDescriptionBodyListItem>
                    <MobileDescriptionBodyListItemText>
                      {t('ShareDocumentLinkDialog.AnyoneOpenShareLink')}
                    </MobileDescriptionBodyListItemText>
                  </MobileDescriptionBodyListItem>
                  <MobileDescriptionBodyListItem>
                    <MobileDescriptionBodyListItemText>
                      {t('ShareDocumentLinkDialog.ShareLinkPeriod', {
                        period: getShareLinkPeriod(appData.productType)
                      })}
                    </MobileDescriptionBodyListItemText>
                  </MobileDescriptionBodyListItem>
                </MobileDescriptionBodyList>
              </MobileDescriptionBody>
            </DialogMobileBody>
          </Dialog>
        </MobileDialogHolder>

        {appData.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE && (
          <MobileADBox>
            <FixedAD id={FIXED_AD_ID.IN_MOBILE_SHARELINK_DIALOG} />
          </MobileADBox>
        )}
      </MobileADNDialogWrapper>
    </Blanket>
  );
}
